import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import IVButton from '@invideoio/uniformd/components/Button';
import ivclass from '../../../../Modules/IVClass';
import GlobalConfig from '../../../../lib/GlobalConfig';
import HeaderItemIcon from '../../HeaderItemIcon';
import MainMenu from './MainMenu';
const MobileMenu = (props) => {
    const { menu, onClose, onLogin, onSignUp, os, platform, logoutRedirectLink, authFunctions, } = props;
    const onCloseClick = () => {
        onClose();
    };
    const CROSS_ICON_MOBILE = {
        url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/cross.svg`,
        alt: 'cross',
        placement: 'suffix',
        width: 12,
        height: 12,
    };
    return (_jsx("div", { className: ivclass('iv-absolute', 'iv-top-[10px] iv-left-[10px]', 'iv-min-h-[calc(100vh-20px)] iv-w-[calc(100vw-20px)]', 'iv-z-40', 'iv-bg-grey-0 dark:iv-bg-grey-85', 'iv-rounded-[20px]', 'iv-shadow-small'), children: _jsxs("div", { className: ivclass('iv-relative', 'iv-flex', 'iv-flex-col', 'iv-pt-25', 'iv-pb-10', 'iv-px-10', 'iv-h-[calc(100vh-20px)]', 'iv-overflow-auto'), children: [_jsx("div", { className: ivclass('iv-absolute', 'iv-right-0 iv-top-0', 'iv-p-20', 'iv-float-right'), children: _jsx(IVButton, { className: ivclass('iv-w-[16px]', 'iv-h-[16px]', 'iv-flex', 'iv-justify-center iv-items-center'), onClick: onCloseClick, children: _jsx(HeaderItemIcon, { icon: CROSS_ICON_MOBILE, className: "" }) }) }), _jsx(MainMenu, { menu: menu, onLogin: onLogin, onSignUp: onSignUp, authFunctions: authFunctions, os: os, platform: platform, logoutRedirectLink: logoutRedirectLink })] }) }));
};
export default MobileMenu;
